export default "__VITE_ASSET__BtP7G1n3__"